import { ReactElement } from 'react';
import * as React from 'react';

import styles from './hubspot-contact-form-modal.module.scss';
import { Popin } from '@utmb/design-system/popin/Popin';
import { HubspotContactForm } from '../HubspotContactForm';
import { LoyaltyLevelEnum } from '@utmb/types/enum/LoyaltyLevelEnum';

interface HubspotContactFormModalProps {
    isOpen: boolean;
    close: () => void;
    currentLevel: LoyaltyLevelEnum;
}

export const HubspotContactFormModal = ({ isOpen, close, currentLevel }: HubspotContactFormModalProps): ReactElement | null => {
    return isOpen ? (
        <Popin closeCallback={() => close()}>
            <div className={styles.hubspotContactFormModal}>
                <HubspotContactForm level={currentLevel} />
            </div>
        </Popin>
    ) : null;
};
